(function () {
  if (window.__csContactBound) return;
  window.__csContactBound = true;

  var overlay = null;
  var sourceRoot = null;

  // Sends an event to whichever analytics tools exist on the page (all optional)
  window.csTrack = function (name, params) {
    params = params || {};
    try {
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params);
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params);
    } catch (err) { /* tracking must never break the form */ }
  };

  function closeContact() {
    if (!overlay) return;
    var el = overlay;
    overlay = null;
    sourceRoot = null;
    el.classList.remove('cs-contact-overlay--open');
    setTimeout(function () { el.remove(); }, 200);
  }

  function openContact(btn) {
    var root = btn.closest('.custom-size-calculator');
    var tpl = root && root.querySelector('.cs-contact-template');
    if (!tpl || overlay) return;
    sourceRoot = root;
    overlay = document.createElement('div');
    overlay.className = 'cs-contact-overlay';
    overlay.dataset.success = tpl.dataset.success || '';
    overlay.dataset.error = tpl.dataset.error || '';
    var dialog = document.createElement('div');
    dialog.className = 'cs-contact-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.innerHTML = '<button type="button" class="cs-contact-close" aria-label="Close">&times;</button>';
    dialog.appendChild(tpl.content.cloneNode(true));
    var wa = dialog.querySelector('.cs-contact-whatsapp');
    var sizeText = sizeSummary(root);
    if (wa && sizeText) wa.href = wa.href + encodeURIComponent(' (' + sizeText + ')');
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('cs-contact-overlay--open'); });
  }

  function sizeSummary(root) {
    if (!root) return '';
    var w = root.querySelector('.cs-width');
    var h = root.querySelector('.cs-height');
    var d = root.querySelector('.cs-diameter');
    var active = root.querySelector('.cs-tab--active');
    var shape = active ? active.getAttribute('data-shape') : 'rectangle';
    if (shape === 'round') return d && d.value ? 'Round ' + d.value + ' cm' : '';
    return w && h && w.value && h.value ? 'Rectangle ' + w.value + ' x ' + h.value + ' cm' : '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-custom-size]')) {
      window.csTrack('custom_size_opened', {});
      return;
    }
    if (e.target.closest('.cs-contact-whatsapp')) {
      window.csTrack('custom_size_whatsapp_click', {});
      return;
    }
    var openBtn = e.target.closest('.cs-contact-btn');
    if (openBtn) {
      e.preventDefault();
      window.csTrack('custom_size_contact_click', {});
      openContact(openBtn);
      return;
    }
    if (overlay && (e.target === overlay || e.target.closest('.cs-contact-close'))) {
      closeContact();
    }
  });

  // Esc closes only the contact popup, not the custom size popup underneath
  document.addEventListener('keydown', function (e) {
    if (overlay && e.key === 'Escape') {
      e.stopPropagation();
      closeContact();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('.cs-contact-form') : null;
    if (!form) return;
    e.preventDefault();

    var sendBtn = form.querySelector('.cs-contact-send');
    var errorEl = form.querySelector('.cs-contact-error');
    var summary = sizeSummary(sourceRoot);

    // Honeypot: real visitors never see or fill this field; bots do. Pretend it worked and send nothing.
    var trap = form.querySelector('.cs-hp-input');
    if (trap && trap.value) {
      closeContact();
      return;
    }

    var data = new FormData(form);
    // Marker so these emails are easy to spot; added to the sent data only, the customer never sees it
    var message = '[Custom size question]\n\n' + (data.get('contact[body]') || '');
    if (summary) message += '\n\nSize entered: ' + summary;
    data.set('contact[body]', message);
    data.set('contact[custom size]', summary);

    errorEl.hidden = true;
    sendBtn.disabled = true;

    fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok || res.url.indexOf('contact_posted=true') === -1) throw new Error('not posted');
        var msg = document.createElement('p');
        msg.className = 'cs-contact-success';
        msg.textContent = (overlay && overlay.dataset.success) || '';
        window.csTrack('custom_size_contact_sent', {});
        form.replaceWith(msg);
        var alt = overlay && overlay.querySelector('.cs-contact-alt');
        if (alt) alt.hidden = true;
        var note = overlay && overlay.querySelector('.cs-contact-note');
        if (note) note.hidden = true;
        var title = overlay && overlay.querySelector('.cs-contact-title');
        if (title) title.hidden = true;
        setTimeout(closeContact, 3500);
      })
      .catch(function () {
        errorEl.textContent = (overlay && overlay.dataset.error) || '';
        errorEl.hidden = false;
        sendBtn.disabled = false;
      });
  });
})();